import { createSlice } from '@reduxjs/toolkit';
import {fetchCommunityHomeownerData } from '../CommunityAPI/communityApi';
import { updateHomeOwnerResidentAddress } from '../../Homeowner/HomeownerApi';

const fetchCommunityHomeownerSlice = createSlice({
  name: 'fetchCommunityHomeowner',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityHomeownerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityHomeownerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityHomeownerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // ================= UPDATE ADDRESS =================
      .addCase(updateHomeOwnerResidentAddress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateHomeOwnerResidentAddress.fulfilled, (state, action) => {
        state.loading = false;

        const { id, resident_address } = action.payload.data;
        const user = state.data.data.data.find((item) => item.id === id);

        if (user) {
          user.resident_address = resident_address;
        }
      })
      .addCase(updateHomeOwnerResidentAddress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default fetchCommunityHomeownerSlice.reducer;
